import { Injectable } from '@angular/core';
import { PersonDependenceGridObject, PersonDependenceObject } from '@libs/types/src/services/object-type/person-dependence.object';
import { GqlServiceV2 } from '../modules/content/service/gql.service-v2';
import { GridInput } from '@it2go/data-grid';
import { filterFrag } from './types/filter.types';
import { IdInput } from '@libs/types/src/common/input-type/id.input';
import { OkObject } from '@it2go/types';
import { PersonDependenceCreateInput, PersonDependenceUpdateInput } from '@libs/types/src/services/input-type/social/person-dependence'

@Injectable({ providedIn: 'root' })
export class PersonDependenceGqlServiceV2 extends GqlServiceV2 {

    public getPersonDependences(input: GridInput | null, frag: string) {
        return this.query<PersonDependenceGridObject>(
            `
                query($input: GridInput!) {
                    personDependence {
                        filter(input: $input) {
                            ${filterFrag}
                            items {
                                ${frag}
                            }
                        }
                    }
                }
            `,
            { input },
        );
    }

    public createPersonDependence(input: PersonDependenceCreateInput, frag: string) {
        return this.mutate<PersonDependenceObject>(
            `
                mutation($input: PersonDependenceCreateInput!) {
                    personDependence {
                        create(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public updatePersonDependence(input: PersonDependenceUpdateInput, frag: string) {
        return this.mutate<PersonDependenceObject>(
            `
                mutation($input: PersonDependenceUpdateInput!) {
                    personDependence {
                        update(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }

    public deletePersonDependence(input: IdInput, frag = 'ok') {
        return this.mutate<OkObject>(
            `
                mutation($input: IdInput!) {
                    personDependence {
                        delete(input: $input) {
                            ${frag}
                        }
                    }
                }
            `,
            { input },
        );
    }
}
